export const customerKeys = {
	options: ["customers", "options"],
};
